
import {TemplateEngine} from "../lib/template-engine";
import {Application} from "../application/application";
import {ChatClientUI} from "./view";
import {Translator} from "../utils/translator";
import webAPI from "../api/web-api-2";
import {JoinedRoomData} from "../chatserver/sx-server";

export class CreditPromo
{
	private isGuest : boolean = false;

	constructor(private $root : JQuery, private app: Application, private view : ChatClientUI, private translator : Translator) {
		this.isGuest = app.options.auth.tokenID == "guest";

		this.checkAndGenerateFirstCreditPromo();
	}

	checkAndGenerateFirstCreditPromo() {

		if(this.isGuest === true) {
			this.generateFirstCreditPromo();
		} else {
			webAPI.post("member/topup/total", {})
				.then((r) => {
					if(r['data'] == 0) {
						this.generateFirstCreditPromo();
					}
				});
		}
	}

	generateFirstCreditPromo() {
		let bgElement = $('<div>').addClass('first-credit-promo-bg');
		let divElement = $('<div>').addClass('first-credit-promo').html(this.translator.t("stream_panel_frist_credit_text"));

		divElement.click(() => {
			if(this.isGuest === true) { this.app.showRegisterNeeded('topup'); return; }

			this.view.topupPanel.needFirstCredit = true;

			$('.sxcc-icon-topup').parent().trigger('click');
		});

		this.$root.append(bgElement).append(divElement);
	}
}
